import * as React from 'react';


type LoadingProps = { loading: boolean };
export const Loading = ({ loading }: LoadingProps) => {
    if (loading) {
        return (
            <div className="text-center loading">
                <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                <p>Laddar...</p>
            </div>
        );
    }
    return null;
};
